// {project}/src/wasmJsMain/resources/sessionStorageUtils.mjs

/**
 * Get an item from sessionStorage
 * @param {string} key - The key to retrieve
 * @returns {string|null} The value or null if not found
 */
export function sessionStorageGetItem(key) {
    return sessionStorage.getItem(key);
}

/**
 * Set an item in sessionStorage
 * @param {string} key - The key to set
 * @param {string} value - The value to store
 */
export function sessionStorageSetItem(key, value) {
    sessionStorage.setItem(key, value);
}

/**
 * Remove an item from sessionStorage
 * @param {string} key - The key to remove
 */
export function sessionStorageRemoveItem(key) {
    sessionStorage.removeItem(key);
}

/**
 * Clear all items from sessionStorage
 */
export function sessionStorageClear() {
    sessionStorage.clear();
}

/**
 * Get the number of items in sessionStorage
 * @returns {number} The number of items
 */
export function sessionStorageLength() {
    return sessionStorage.length;
}

/**
 * Get the key at a specific index in sessionStorage
 * @param {number} index - The index
 * @returns {string|null} The key or null if index is out of bounds
 */
export function sessionStorageKey(index) {
    return sessionStorage.key(index);
}
